(function () {
  var status = document.getElementById("backdrop-status");
  var verb = document.getElementById("backdrop-status-verb");
  var label = document.getElementById("backdrop-status-label");

  if (!status || !verb || !label) {
    return;
  }

  var supportsBackdrop = false;
  if (window.CSS && typeof window.CSS.supports === "function") {
    supportsBackdrop =
      window.CSS.supports("backdrop-filter", "blur(1px)") ||
      window.CSS.supports("-webkit-backdrop-filter", "blur(1px)");
  }

  status.classList.remove("status-backdrop--unknown");
  if (supportsBackdrop) {
    status.classList.add("status-backdrop--supported");
    verb.textContent = "does";
    label.textContent = "support";
  } else {
    status.classList.add("status-backdrop--unsupported");
    verb.textContent = "does not";
    label.textContent = "support";
  }
})();
